export const clampTimeValue = (
  value: number,
  type: 'hours' | 'minutes',
): number => {
  if (type === 'hours') {
    return Math.max(0, Math.min(23, value));
  } else if (type === 'minutes') {
    return Math.max(0, Math.min(59, value));
  }
  return value; // Fallback, though this should never happen with 'hours' or 'minutes'
};
